<template lang="pug">
  #app(v-scroll="handleScroll")
    app-header(ref="header")

    router-view

    app-footer

    transition(name="fade")
      app-modal.clr-black(
        v-if="modalVisible"
        :class="{show: modalVisible}"
        :title="modalTitle"
      )
</template>

<script>
import getScrollDirection from '@/helpers/get-scroll-direction'
import appHeader from '@/components/common/Header'
import appFooter from '@/components/common/Footer'
import appModal from '@/components/common/Modal'

export default {
  components: {
    appHeader,
    appFooter,
    appModal
  },
  computed: {
    headerHeight () {
      return this.$store.getters.headerHeight
    },
    modalVisible () {
      return this.$store.getters.modal.visible
    },
    modalTitle () {
      return this.$store.getters.modal.title
    }
  },
  methods: {
    handleScroll (evt, el) {
      const down = getScrollDirection() === 1
      const up = getScrollDirection() === -1

      if (down) {
        this.$refs.header.$el.classList.add(`down`)
        this.$refs.header.$el.classList.remove(`up`)
      }

      if (up) {
        this.$refs.header.$el.classList.remove(`down`)
        this.$refs.header.$el.classList.add(`up`)

        if (window.scrollY > this.headerHeight) {
          this.$refs.header.$el.classList.add(`scroll`)
        } else {
          this.$refs.header.$el.classList.remove(`scroll`)
        }
      }
    }
  },
  mounted () {
    this.$el.addEventListener(`click`, this.closeModal)
  },
  beforeDestroy: function () {
    this.$el.removeEventListener('click', this.closeModal)
  }
}
</script>

<style lang="scss">
  #app {
    display: flex;
    flex-direction: column;

    @include respond-max(tablet) {
      overflow: hidden;
    }
  }

  .fade-enter-active {
    animation: fade-in 0.25s linear forwards;
  }

  .fade-leave-active {
    animation: fade-out 0.25s linear forwards;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fade-out {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .notification {
    position: fixed;
    z-index: 10;
    top: var(--header-height);
    right: $offset-desktop;
    padding: 50px;
    text-align: center;
    background-color: #fff;
    box-shadow: 0px 16px 16px rgba(26, 32, 59, 0.16);

    @include respond-max(tablet) {
      top: 50%;
      left: $offset-mobile;
      right: $offset-mobile;
      transform: translateY(-50%);
    }
  }
</style>
